<div class="flex items-center justify-center p-6">
  <fip-reduction-shipment-size-form
    [formGroup]="formGroup"
    (submitForm)="submit()"
  >
  </fip-reduction-shipment-size-form>
</div>
